import * as React from 'react';
import { ITopCardsProps } from './TopCardsContainer';
import { determineUnitToShow } from 'helpers/conversions';
import { useTranslation } from 'react-i18next';
import DesktopTopCards from './DesktopTopCards';
import { text } from './textData';
import MobileTopCards from './MobileTopCards';

const TopCards = (props: ITopCardsProps) => {
  const { t } = useTranslation();
  const { selectedSystemGroup, userSettings, isMobile } = props;
  const units = determineUnitToShow(selectedSystemGroup, userSettings, t);
  const selectedSystemGroupText = text[selectedSystemGroup]!;
  const topCardsProps = {
    ...props,
    selectedSystemGroup,
    units,
    selectedSystemGroupText,
  };

  if (!isMobile) {
    return <DesktopTopCards {...topCardsProps} />;
  }
  return <MobileTopCards {...topCardsProps} />;
};
export default React.memo(TopCards);
